/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

import MAINTENANCE_TYPE from 'utils/__enums/SuperAdministration/Maintenance'

/** Components */
import ROUTES from 'utils/ROUTES'
import ScreenContainerSimpleLayoutConnexion from 'layouts/ScreenContainerSimpleLayoutConnexion'
import MaintenanceContent from 'layouts/Maintenance/MaintenanceContent'

interface PreviewProps {
  content: string | null
  displayForm?: boolean
  templateType?: number
  maintenanceType: string
  isPreview: boolean
}

declare global {
  interface Window {
    previewProps?: PreviewProps
    previewWindowRef?: Window | null
  }
}

const Maintenance: FC = () => {
  const history = useHistory()

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [input, setInput] = useState<string[]>([])
  const konamiCodeEnv = process.env.REACT_APP_KONAMI_CODE ?? ''
  const konamiCode = konamiCodeEnv.split(';')

  const softMaintenanceMode = localStorage.getItem(
    `maintenanceMode${MAINTENANCE_TYPE.ALL}`
  )

  useEffect(() => {
    const handleKeyDown = (event: any) => {
      if (softMaintenanceMode === 'true') {
        setInput((prevInput: string[]) => {
          const newInput = [...prevInput, event.key].slice(-konamiCode.length)
          if (newInput.join('') === konamiCode.join('')) {
            sessionStorage.setItem('konamiAccess', btoa(konamiCodeEnv))
            history.push(ROUTES.Home)

            return [] // Reset input after success
          }
          return newInput
        })
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [konamiCode, konamiCodeEnv, softMaintenanceMode])

  return (
    <ScreenContainerSimpleLayoutConnexion isLogoClickable={false}>
      <MaintenanceContent />
    </ScreenContainerSimpleLayoutConnexion>
  )
}

export default Maintenance
